// Завантаження файлів з API (XLSX / CSV / PDF / iCal) з авторизацією і refresh-повтором.
// downloadFile('/directories/rooms/export.xlsx', { fallbackName: 'Аудиторії.xlsx' }) — зберігає файл у браузері.
import { execute, type RequestOptions } from './api';

/** Ім'я файлу з Content-Disposition (RFC 5987 filename* має пріоритет). */
export function filenameFromDisposition(header: string | null): string | null {
  if (!header) return null;
  const star = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ''));
    } catch {
      /* далі — звичайний filename */
    }
  }
  const plain = /filename\s*=\s*"([^"]*)"|filename\s*=\s*([^;]+)/.exec(header);
  if (plain) return (plain[1] ?? plain[2] ?? '').trim() || null;
  return null;
}

/** Зберегти Blob як файл. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export interface DownloadOptions extends RequestOptions {
  method?: 'GET' | 'POST';
  /** Ім'я, якщо сервер не передав Content-Disposition. */
  fallbackName?: string;
  /** false — лише повернути Blob (напр. для перегляду PDF), не зберігати. */
  save?: boolean;
}

/** Завантажити файл з API (шлях без префікса /api). Кидає ApiError з українським текстом. */
export async function downloadFile(path: string, opts: DownloadOptions = {}): Promise<{ blob: Blob; filename: string }> {
  const res = await execute(opts.method ?? 'GET', path, {
    ...opts,
    headers: { Accept: '*/*', ...opts.headers },
  });
  const blob = await res.blob();
  const filename = filenameFromDisposition(res.headers.get('Content-Disposition')) ?? opts.fallbackName ?? 'файл';
  if (opts.save !== false) saveBlob(blob, filename);
  return { blob, filename };
}
